import {z} from 'zod';

const supplierSchema = z
  .object({
    enabled: z.boolean().default(false),
    name: z.array(z.string()).optional()
  })
  .superRefine((data, ctx) => {
    if (data.enabled) {
      if (!data.name || data.name.length === 0 || data.name.every(n => n.trim() === '')) {
        ctx.addIssue({
          path: ['name'],
          code: z.ZodIssueCode.custom,
          message: 'Nom requis lorsque le switch est activé'
        });
      }
    }
  });

const practitionerSchema = z.object({
  lastName: z.string().min(1, 'Nom requis'),
  firstName: z.string().min(1, 'Prénom requis'),
  gender: z.enum(['male', 'female']),

  avgAppointmentDelay: z.number({required_error: 'Délai requis', invalid_type_error: 'Doit être un nombre'}).min(0, 'Doit être positif'),

  specialties: z.object({
    omniPractice: z.boolean().default(false),
    implantology: z.boolean().default(false),
    orthodontics: z.boolean().default(false),
    periodontology: z.boolean().default(false),
    endodontics: z.boolean().default(false),
    other: z.array(z.string()).min(0)
  }),

  opticalImpression: z.boolean().default(false),
  cerecCFAO: z.boolean().default(false),

  implantSupplier: supplierSchema,
  orthoLabSupplier: supplierSchema,
  alignerSupplier: supplierSchema,
  prosthesisSupplier: supplierSchema,

  implantPrice: z
    .object({
      min: z.number({invalid_type_error: 'Doit être un nombre'}).nullable().optional(),
      max: z.number({invalid_type_error: 'Doit être un nombre'}).nullable().optional()
    })
    .nullable()
    .optional(),

  orthoPrice: z
    .object({
      child: z.number({invalid_type_error: 'Doit être un nombre'}).nullable().optional(),
      adult: z.number({invalid_type_error: 'Doit être un nombre'}).nullable().optional()
    })
    .nullable()
    .optional(),

  alignerPrice: z
    .object({
      adult: z.number({invalid_type_error: 'Doit être un nombre'}).nullable().optional()
    })
    .nullable()
    .optional(),

  ceramicCrownPrice: z
    .object({
      min: z.number({invalid_type_error: 'Doit être un nombre'}).nullable().optional(),
      max: z.number({invalid_type_error: 'Doit être un nombre'}).nullable().optional()
    })
    .nullable()
    .optional()
});

export default practitionerSchema;
